import React, { useState, useEffect } from 'react';
import { TextField, Collapse, List, ListItemButton, ListItemText } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {getAllLeaveType} from "../../../../../services/leave";

import { tokens } from "../../../../../theme";
export default function CustomSelect({onLeaveSelect}) {
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getAllLeaveType();
        console.log(res); 
        setOptions(res.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
    fetchData();
  }, []);

  const handleToggle = () => {setOpen(!open)};

  const handleOptionSelect = (option) => {
    setSelectedOption(option.name);
    setOpen(false);
    onLeaveSelect(option._id);
  };

  return (
    <div>
      <TextField
        variant="outlined"
        onClick={handleToggle}
        placeholder="Leave Type"
        value={selectedOption}
        fullWidth
        InputProps={{
          readOnly: true,
          endAdornment: <ExpandMoreIcon />
        }}
        sx={{
            "& .MuiInputBase-root":{
                backgroundColor:"#F1E4E6",
                borderRadius: "6px",
                fontSize:"1rem",
                lineHeight:1.7,
                color:tokens.pendingText
            }
          }} 
      />
      <Collapse in={open}>
        <List>
          {options.map((option) => (
            <ListItemButton key={option.id} onClick={() => handleOptionSelect(option)}>
              <ListItemText 
               primary={option.name} 
               sx={{
                fontSize:"1rem",
                lineHeight:1.7,
                color:tokens.pendingText,
                borderBottom:"1px solid #F5E9E1",
                padding:0
               }} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </div>
  );
}
